import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var Calendar3Icon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#calendar-1__a)",
                            children: [
                                _jsx("path", {
                                    d: "M22.595 3.8c-.49-.49-1.14-.76-1.83-.76h-2.18V1.65c0-.55-.45-1-1-1s-1 .45-1 1v4.78c0 .55.45 1 1 1s1-.45 1-1V5.04h2.18c.16 0 .31.06.42.17.11.11.17.26.17.42v15.13c0 .16-.06.31-.17.42a.59.59 0 01-.42.17H3.245a.59.59 0 01-.42-.17.59.59 0 01-.17-.42V5.63c0-.16.06-.31.17-.42a.59.59 0 01.42-.17c.55 0 1-.45 1-1s-.45-1-1-1c-.69 0-1.34.27-1.83.76s-.76 1.14-.76 1.83v15.13c0 .68.28 1.35.76 1.83.49.49 1.14.76 1.83.76h17.51c.69 0 1.34-.27 1.83-.76s.76-1.15.76-1.83V5.63c0-.69-.27-1.34-.76-1.83h.01z"
                                }),
                                _jsx("path", {
                                    d: "M6.435 7.43c.55 0 1-.45 1-1V5.04h6.96c.55 0 1-.45 1-1s-.45-1-1-1h-6.96V1.65c0-.55-.45-1-1-1s-1 .45-1 1v4.78c0 .55.45 1 1 1zM17.775 12c0-.55-.45-1-1-1h-6.37c-.55 0-1 .45-1 1s.45 1 1 1h6.37c.55 0 1-.45 1-1zm-7.36 3.78c-.55 0-1 .45-1 1s.45 1 1 1h1.59c.55 0 1-.45 1-1s-.45-1-1-1h-1.59zM6.435 13h.8c.55 0 1-.45 1-1s-.45-1-1-1h-.8c-.55 0-1 .45-1 1s.45 1 1 1zm0 4.78h.8c.55 0 1-.45 1-1s-.45-1-1-1h-.8c-.55 0-1 .45-1 1s.45 1 1 1z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "calendar-1__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
Calendar3Icon.isCarinaIcon = true;
export default Calendar3Icon;
